import React, {useContext} from "react";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {isEmpty} from "lodash";
import Row from "../../../../../../components/tag/Row";
import {FormattedMessage} from "react-intl";
import Span from "../../../../../../components/tag/Span";


export const TimelineFrameContentLabResearch = () => {
    const { data } = useContext(TimelineFrameDataContext);
    const { tests } = data;

    if (isEmpty(tests)) {
        return <></>
    }

    return (
        <>
            <Row>
                <div className="notification-info">
                    <FormattedMessage id="fimlab.tests.info" />
                </div>
            </Row>
            <Row>
                <Span>
                    <ul className="splash">
                        { tests.map((test) => {
                                return test.labTestName == null ? (
                                    <li
                                        className="infoList"
                                        key={`${test.labTestId}-${test.labTestAbbreviation}`}
                                    >
                                        {test.labTestId} - {test.labTestAbbreviation}
                                    </li>
                                ) : (
                                    <li
                                        className="infoList"
                                        key={`${test.labTestId}-${test.labTestAbbreviation}`}
                                    >
                                        {test.labTestId} - {test.labTestAbbreviation},{' '}
                                        {test.labTestName}
                                    </li>
                                );
                            })}
                    </ul>
                </Span>
            </Row>
        </>
    )

}